import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPageNew from "../../components/HelpSupport/ViewHelpSupportPageNew";



const ViewHelpSupportPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Help & Support" link2="/help" title="View Help & Support" />

        {/* AddUserLayer */}
        <ViewPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewHelpSupportPage;
